module.exports = __webpack_public_path__ + "static/k9-kommando-c025d7e905b8a42b99f1cf2768ce2b75.png";